module.exports = __webpack_public_path__ + "493ff947f714d8cf0cd1025dfcfa47a5.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/1.m4a
// module id = 970
// module chunks = 4